'use strict';
import {Button} from 'react-bootstrap';
import axios from 'axios';
import crypto from 'crypto-js';
import { Base64 } from 'js-base64';
/**
 * Creates object with helpers for accessing to Liqpay API
 *
 * @param {string} public_key
 * @param {string} private_key
 *
 * @throws {Error}
 */
function LiqPay(public_key, private_key) {
    /**
     * @member {string} API host
     */
    this.host = "https://www.liqpay.ua/api/";

    this.availableLanguages = ['ru', 'uk', 'en'];

    this.buttonTranslations = {'ru': 'Оплатить', 'uk': 'Карта Visa, MasterCard', 'en': 'Card Visa, MasterCard'};
    /**
     * Call API
     *
     * @param {string} path
     * @param {object} params
     * @return {object}
     * @throws {Error}
     */
    this.api = async function api(path, params) {
        if (!params.version) {
            throw new Error('version is null');
        }

        params.public_key = public_key;
        const data = Buffer.from(JSON.stringify(params)).toString('base64');
        const signature = this.str_to_sign(private_key + data + private_key);

        const dataToSend = new URLSearchParams();
        dataToSend.append('data', data);
        dataToSend.append('signature', signature);

        try {
            const response = await axios.post(this.host + path, dataToSend, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error(`Request failed with status code: ${response.status}`);
            }
        } catch (error) {
            throw error;
        }
    };

    /**
     * cnb_form
     *
     * @param {object} params
     *
     * @return {string}
     *
     * @throws {Error}
     */
    this.cnb_form = function cnb_form(params,isvalid) {
        let buttonText = this.buttonTranslations['uk'];
        if (params.language) {
            buttonText = this.buttonTranslations[params.language] || this.buttonTranslations['uk'];
        }

        params = this.cnb_params(params);
        const data = Base64.encode(JSON.stringify(params));
        const logoPath = require('../src/assets/logo-liqpay-fractional_2x-e1611061658182-removebg-preview.png'); //
        const signature = this.str_to_sign(private_key + data + private_key);
        if(isvalid)
         {   return `
        <form method="POST" action="https://www.liqpay.ua/api/3/checkout" accept-charset="utf-8">
            <input type="hidden" name="data" value="${data}" />
            <input type="hidden" name="signature" value="${signature}" />
            <button type="submit" class="btn btn-light" style="border-radius: 0;font-weight: bolder; width: 100%;  color: black;border-color:black; border-width: 1px; padding: 10px 20px; cursor: pointer; display: flex; align-items: center; justify-content: space-between;">
                <span >${buttonText}</span>
                <img src="${logoPath}" alt="LiqPay Logo" style="height: 100%;width:90px" />
            </button>
        </form>`;
}
else
{
    return  '<Button disabled style="border-radius: 0;width:100%; background-color: #343a40; color: #000; border: none; padding: 10px 20px; cursor: pointer;">' + buttonText + '</Button>' 
}
    };

    /**
     * cnb_signature
     *
     * @param {object} params
     *
     * @return {string}
     *
     * @throws {InvalidArgumentException}
     */
    this.cnb_signature = function cnb_signature(params) {
        params = this.cnb_params(params);
        const data = Buffer.from(JSON.stringify(params)).toString('base64');
        return this.str_to_sign(private_key + data + private_key);
    };

    /**
     * cnb_params
     *
     * @param {object} params
     *
     * @return {object} params
     *
     * @throws {Error}
     */
    this.cnb_params = function cnb_params(params) {
        params.public_key = public_key;

        // Validate and convert version to number
        if (params.version) {
            if (typeof params.version === 'string' && !isNaN(Number(params.version))) {
                params.version = Number(params.version);
            } else if (typeof params.version !== 'number') {
                throw new Error('version must be a number or a string that can be converted to a number');
            }
        } else {
            throw new Error('version is null');
        }

        // Validate and convert amount to number
        if (params.amount) {
            if (typeof params.amount === 'string' && !isNaN(Number(params.amount))) {
                params.amount = Number(params.amount);
            } else if (typeof params.amount !== 'number') {
                throw new Error('amount must be a number or a string that can be converted to a number');
            }
        } else {
            throw new Error('amount is null');
        }

        // Ensure other parameters are strings
        const stringParams = ['action', 'currency', 'description', 'language'];
        for (const param of stringParams) {
            if (params[param] && typeof params[param] !== 'string') {
                params[param] = String(params[param]);
            } else if (!params[param] && param !== 'language') { // language is optional
                throw new Error(`${param} is null or not provided`);
            }
        }

        // Check if language is set and is valid
        if (params.language && !this.availableLanguages.includes(params.language)) {
            params.language= 'uk';
        }

        return params;
    };


    /**
     * str_to_sign
     *
     * @param {string} str
     *
     * @return {string}
     *
     * @throws {Error}
     */
    this.str_to_sign = function str_to_sign(str) {
        if (typeof str !== 'string') {
            throw new Error('Input must be a string');
        }

        const sha1 = crypto.SHA1(str);
        return sha1.toString(crypto.enc.Base64);
    };

    /**
     * Return Form Object
     *
     * @param {object} params
     *
     * @returns {{ data: string, signature: string }} Form Object
     */
    this.cnb_object = function cnb_object(params) {
        params.language = params.language || "uk";
        params = this.cnb_params(params);
        const data = Buffer.from(JSON.stringify(params)).toString('base64');
        const signature = this.str_to_sign(private_key + data + private_key);
        return {data: data, signature: signature};
    };

    return this;
}

export default LiqPay;
